import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './DeleteModal.scss'; // Corrected the name

const DeleteModal = (props) => {
  return (
    <Modal
      show={props.isConfirm}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => props.handleClose(false)}
      centered
    >
      <Modal.Header onClick={() => props.handleClose(false)} closeButton />
      <Modal.Body>
        <div className='delete-modal-wrapper'>
          <div className='icon-wrap'>
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 20 20">
              <path fill="#7f29d6" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m2-13c0 .28-.21.8-.42 1L10 9.58c-.57.58-1 1.6-1 2.42v1h2v-1c0-.29.21-.8.42-1L13 9.42c.57-.58 1-1.6 1-2.42a4 4 0 1 0-8 0h2a2 2 0 1 1 4 0m-3 8v2h2v-2z" />
            </svg>
          </div>
          <h2 className='modal-title text-center'>Are you sure?</h2>
          <div className='modal-sub-title'>{props.text}?</div>
          <div className='w-100 confirm-btn-wrapper'>
            <Button onClick={() => props.isConfirm()} variant='outline-primary'>Yes, Delete</Button>
            <Button onClick={() => props.handleClose(false)} variant='outline-primary'>No, Keep My Profile</Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteModal;
